'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'search',
  aliases: [],
  colors: [],
  path: _react2.default.createElement('path', {
    unicode: '\uF002',
    glyphName: 'search',
    transform: 'scale(1,-1) translate(-60, -1400)',
    vertAdvY: '1400',
    d: 'M1152 704q0 185 -131.5 316.5t-316.5 131.5t-316.5 -131.5t-131.5 -316.5t131.5 -316.5t316.5 -131.5t316.5 131.5t131.5 316.5zM1664 -128q0 -52 -38 -90t-90 -38q-54 0 -90 38l-343 342q-179 -124 -399 -124q-143 0 -273.5 55.5t-225 150t-150 225t-55.5 273.5\nt55.5 273.5t150 225t225 150t273.5 55.5t273.5 -55.5t225 -150t150 -225t55.5 -273.5q0 -220 -124 -399l343 -343q37 -37 37 -90z'
  }),
  viewBox: '0 0 1536 1664'
};


//////////////////
// WEBPACK FOOTER
// ./~/tanda-components/Icon/svgs/search.js
// module id = 1595
// module chunks = 0